// extracted by mini-css-extract-plugin
export default {"bulletPoints":"bulletPoints_ef654"};